import S20001 from '../assets/images/thumbnails/2000S1.jpg'
import S20001P from '../assets/images/preview/2000S1P.png'
import DMLT from '../assets/images/thumbnails/DML.jpg'
import DMLP from '../assets/images/preview/DMLP.png'
import E2000S2 from '../assets/images/thumbnails/2000S.png'
import S2000SP from '../assets/images/preview/S2000SP.png'
import CADMBP from '../assets/images/preview/CADMBP.png'
import CADMB from '../assets/images/thumbnails/CADMBR.png'
import DMBD from '../assets/images/thumbnails/DMBD.png'
import DMBDP from '../assets/images/preview/DMBDP.png'
import TMDLOGO from '../assets/images/logo/logotmd.jpg'
import ENTRET from '../assets/images/thumbnails/ENTRET.png'
import ENTREP from '../assets/images/preview/ENTREP.png'
import DMBR from '../assets/images/thumbnails/DMBR.jpg'
import TMDT from '../assets/images/thumbnails/TMD.jpg'
import PCA from '../assets/images/thumbnails/PYA.jpg'
import QPTMD2 from '../assets/images/thumbnails/QPTMD2.jpg'
import REGRESO from '../assets/images/thumbnails/REGRESO.png'

const Extras = [
    {
        id: 1,
        section: 'Extra',
        title: '2000 Subs FTW',
        thumbnailUrl: S20001,
        webUrl: 'https://www.youtube.com/embed/pfGrzfRE4b8', // Add the episode URL
        backgroundImage: S20001P,
        seriesLogo: TMDLOGO,
        description: 'Muchas muchas gracias! Mi meta en un principio era 1000, pero ahora somos el doble! Realmente, muchas gracias! :)',
      },
      {
        id: 2,
        section: 'Extra',
        title: 'TMD : Draw My Life / Draw My Life in Youtube',
        thumbnailUrl: DMLT,
        webUrl: 'https://www.youtube.com/embed/ZtmJYsjWgCc', // Add the episode URL
        backgroundImage: DMLP,
        seriesLogo: TMDLOGO,
        description: 'Ustedes lo pidieron, y lo obtuvieron, disculpen la no muy buena calidad, no es fácil grabar un Draw My Life XD. Disfrutenlo, y conozcan un poco más de mi :D. Bueno... por alguna increíblemente extraña razón, muchos creen que yo he insultado al país sudamericano Chile en este video... Y yo así como de O______________________________O WTF!!!! Al decir que no hablaba del país en realidad hablaba del alimento que aquí llamamos "chile", si no lo conoces, es un alimento famoso aquí en México, aún así, no se como rayos se entiende que yo insulté al país, o sea, ¿Dónde diantres se supone que está el insulto? O_O Sería todo lo contrario, en verdad no he visitado esta gran sección del mundo, pero existe el Internet y me he sabido informar sobre su cultura y forma de vivir, que me ha agradado de forma personal influenciando en mis gustos :D',
      },
      {
        id: 3,
        section: 'Extra',
        title: '¿Qué pasó con TheMarioDimension2',
        thumbnailUrl: QPTMD2,
        webUrl: 'https://www.youtube.com/embed/0gcJCRUKAYcqIYzv', // Add the episode URL
        backgroundImage: QPTMD2,
        seriesLogo: TMDLOGO,
        description: 'Gracias a los que me apoyaron este año. Vamos a tratar de recuperar un poco de lo perdido. Cualquier novedad o información se las compartiré por aquí.',
      },
      {
        id: 4,
        section: 'Extra',
        title: 'El Regreso',
        thumbnailUrl: REGRESO,
        webUrl: 'https://www.youtube.com/embed/0gcJCRUKAYcqIYzv', // Add the episode URL
        backgroundImage: REGRESO,
        seriesLogo: TMDLOGO,
        description: 'Hora del comeback! No se pierdan cual es el plan para regresar y mejor que nunca...',
      },
      {
        id: 5,
        section: 'Extra',
        title: 'DMB Direct',
        thumbnailUrl: DMBD,
        webUrl: 'https://www.youtube.com/embed/UA5Gx1fuJP8', // Add the episode URL
        backgroundImage: DMBDP,
        seriesLogo: TMDLOGO,
        description: 'Hola a todos y bienvenidos al directo de DMB, donde encontrarán lo último de información acerca de esta serie. No se olviden de suscribirse, darle like y más importante, compartir. Ojalá lo disfruten y no se olviden de ver de principio a fin...',
      },
      {
        id: 6,
        section: 'Extra',
        title: 'Critiquemos a Dúper Mario Bros',
        thumbnailUrl: CADMB,
        webUrl: 'https://www.youtube.com/embed/E-gvbx7nqIc', // Add the episode URL
        backgroundImage: CADMBP,
        seriesLogo: TMDLOGO,
        description: 'Hoy toca hacer review a esta amada serie, y que mejor, tambien veremos lo que opinan ustedes!!',
      },
      {
        id: 7,
        section: 'Extra',
        title: '2000 Subs FTW - TheMarioDimension2',
        thumbnailUrl: E2000S2,
        webUrl: 'https://www.youtube.com/embed/j1zk--prg70', // Add the episode URL
        backgroundImage: S2000SP,
        seriesLogo: TMDLOGO,
        description: '2000 Subscriptores se dice facil pero es un logro muy grande para este canal. Gracias y vamos por los 10000 :)',
      },
      {
        id: 8,
        section: 'Extra',
        title: 'El Regreso de TheMarioDimension - Entrevista Completa',
        thumbnailUrl: ENTRET,
        webUrl: 'https://www.youtube.com/embed/zrxr8-TJXP0', // Add the episode URL
        backgroundImage: ENTREP,
        seriesLogo: TMDLOGO,
        description: 'El regreso de TheMarioDimension. Despues de 11 años, Rodrigo regresa a platicarnos no solo de su estado actual, sino tambien de su trayectoria en YouTube. No tengo palabras para describir lo afortunado que me siento de traerles esta entrevista. Gracias @TheZeldaDimension por tomarte el tiempo de participar en este proyecto! Gracias a @ElHasb y @ELROJIZO54 por ayudar en la parte visual y en las preguntas. Y a @LeBasth por la miniatura.',
      },
      {
        id: 9,
        section: 'Extra',
        title: 'dúper mario',
        thumbnailUrl: DMBR,
        webUrl: 'https://www.youtube.com/embed/mFPcrhUzaBU', // Add the episode URL
        backgroundImage: DMBR,
        seriesLogo: TMDLOGO,
        description: '',
      },
      {
        id: 10,
        section: 'Extra',
        title: 'TheMarioDimension',
        thumbnailUrl: TMDT,
        webUrl: 'https://www.youtube.com/embed/Z1p8sNJfG1g', // Add the episode URL
        backgroundImage: TMDT,
        seriesLogo: TMDLOGO,
        description: 'Hey:)',
      },
      {
        id: 11,
        section: 'Extra',
        title: 'Proyectos y Animaciones de TheMarioDimension que nunca salieron',
        thumbnailUrl: PCA,
        webUrl: 'https://www.youtube.com/embed/k8_VZUUEIlg', // Add the episode URL
        backgroundImage: PCA,
        seriesLogo: TMDLOGO,
        description: 'Hola amigos:) el día de hoy les quiero compartir algunos trabajos y material del pasado que encontré entre mis archivos y que nunca llegué a terminar o siquiera sacar a la luz.',
      },
  ];

  export default Extras;
